import ChatInterface from "@/components/chat/ChatInterface";
import React from "react";

const Chat: React.FC = () => {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex gap-4 flex-col lg:flex-row h-[calc(100dvh-120px)]">
        <ChatInterface />
      </div>
    </div>
  );
};

export default Chat;
